export enum CaosConfigurationTemplateContentsEnum {
    none = 0x00000000,
    generalConfigurations = 0x00000001,
    deviceGroups = 0x00000002,
    deviceGroups_channels = 0x00000004,
    deviceGroups_opByGroups = 0x00000008,
    deviceGroups_kits = 0x00000010,
    deviceUsers = 0x00000020,
    adminGroups = 0x00000040,
    adminUsers = 0x00000080,
    channels = 0x00000100,
    kits = 0x00000200,
    channels_kits = 0x00000400,
    shifts = 0x00000800,
    schedules = 0x00001000,
    reports = 0x00002000,
}
const binding = ["deviceGroups_channels", "deviceGroups_opByGroups", "deviceGroups_kits", "channels_kits"];

export function caosConfigurationTemplateContentToString(value: CaosConfigurationTemplateContentsEnum, withBinding: boolean = false): string[] {
    let finalString = [];
    for (let content in CaosConfigurationTemplateContentsEnum) {
        if (((CaosConfigurationTemplateContentsEnum[content] as any) & value) != CaosConfigurationTemplateContentsEnum.none) {
            if (binding.includes(content) && withBinding) {
                finalString.push(`enum.caosConfigurationTemplateContents.${content}`);
            } else if (!binding.includes(content)) finalString.push(`enum.caosConfigurationTemplateContents.${content}`);
        }
    }
    return finalString;
}

export function i18nToEnum(i18nName: string): CaosConfigurationTemplateContentsEnum {
    let name = i18nName.replace("enum.caosConfigurationTemplateContents.", "");
    return CaosConfigurationTemplateContentsEnum[name];
}
